const coldChainStore = {
  state: {
    coldChain: [],
    product: null,
    productInfo: {
      companyName: null,
      category: null,
      products: []
    },
    chainType: null
  },
  mutations: {
    setColdChain (state, coldChain) {
      state.coldChain = coldChain
    },
    setProduct (state, productInfo) {
      state.product = productInfo
    },
    setProductInfo (state, productInfo) {
      state.productInfo = productInfo
    },

    setChainType (state, chainType) {
      state.chainType = chainType
    }
  },

  actions: {
  },

  getters: {
    coldChain: state => state.coldChain,
    productStore: state => state.product,
    productInfoStore: state => state.productInfo,
    storeChainType: state => state.chainType
  }

}
export default coldChainStore
